module.exports = "/virtual-football-league/img/amblems/right/logos/CELTA VIGO.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/CELTA VIGO.png
// module id = 2166
// module chunks = 4